exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  position: absolute; }\n\n.root {\n  width: auto;\n  height: auto; }\n", ""]);

// exports
